import {
    PartyListState,
    UserActionTypes,
    GET_PARTY_LIST_SUCCESS,
    GET_SECURITY_PROFILE_SUCCESS,
    GET_PARTY_SUCCESS,
    GET_AGENT_STATE_SUCCESS,
    partyInit,
    agentStateInfoInitialState,
    securityProfileInit,
    GET_AIRLINE_SUCCESS
} from './types'


/****************************Agent Profile********************************/

export function securityProfile(state = securityProfileInit, action: UserActionTypes) {
    switch (action.type) {
        case GET_SECURITY_PROFILE_SUCCESS:
            return action.payload.data;
        default:
            return state
    }
}

/************************************************************/
export function party(state = partyInit, action: UserActionTypes) {
    switch (action.type) {
        case GET_PARTY_SUCCESS:
            return action.payload.data;
        default:
            return state
    }
}


const userInitialState: PartyListState = {
    data: [],
    total: 0
}
export function partyList(state = userInitialState, action: UserActionTypes) {
    switch (action.type) {
        case GET_PARTY_LIST_SUCCESS:
            return action.payload;
        default:
            return state
    }
}


export function agentStateInfo(state = agentStateInfoInitialState, action: UserActionTypes) {
    switch (action.type) {
        case GET_AGENT_STATE_SUCCESS:
            return action.payload?.data;
        default:
            return state
    }
}

/************************************************************/
export function currentAirline(state = { data: null }, action: UserActionTypes) {
    switch (action.type) {
        case GET_AIRLINE_SUCCESS:
            return action.payload;
        default:
            return state
    }
}